import Command from './Command';
import AjaxRemoteUtil from '../utils/AjaxRemoteUtil';
import CommonUtil from '../utils/CommonUtil';

export default class ServiceHelper
{
	static addTokenWithCommand(options)
	{
	  var defaults = 
	  {
		command:null,resultFunction:null,sync:true,faultFunction:null,autoLock:true,
		autoUnlock:true,localLock:true,autoCreateGongqiSession:true,_ishttps:false,logArgs:null,
		_iszhiding:false,fixCallFaultFunc:false,successIngnoreStatus:false,lockText:"系统正在拉取数据 请稍后..."
	  };

	  Object.assign(defaults, options);
	  if(defaults.command)
	  	defaults.command.requestUUID = CommonUtil.guid();
	  let obj;
	  let userInfos;
	  try
	  {
		userInfos = window.userInfos || window.parent.window.userInfos;
	  }
	  catch(e)
	  {
		//如果是跨域 如外链应用 需要自动登录 则该接口日志记录不需要用户信息 自动登录完成以后  window.userInfos自然会获取用户信息
	  }
	  if(!userInfos)userInfos={};
	  if(defaults.command && userInfos)
	  {
		  if(!(
			  defaults.command.classType == "service"&&defaults.command.className == "gongqi.erp.framework.services.ClientLoggingService"&&defaults.command.methodName=="saveLog"
		  ))
		  {
			  let command = defaults.command;
			  obj = {remoteClass:"java.util.Map"};
			  obj.requestId = command.requestUUID;
			  obj.dataArea = userInfos.subSysId;
			  obj.userId = userInfos.userId;
			  obj.userName = userInfos.userName;
			  obj.clientSessionId = userInfos.userSessionId;
			  obj.startDateTime = new Date().getTime();
			  obj.classType = command.classType;
			  obj.className = command.className;
			  obj.methodName = command.methodName;
			  obj.remark = (command.logArgs&&command.logArgs.length>0)?JSON.stringify(command.logArgs):"";
		  }
	  }

	  let url;let domain = window.didomain;
	  let loginToken = window.loginToken;
	  let loginDataArea = window.loginDataArea;
	  try//zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
	  {
		if(!domain && window.parent && window.parent.window)
			domain = window.parent.window.didomain;
		if(domain)
			url = "/GongqiERP/"+domain+"/ServiceController";
		else
			url = "/GongqiERP/ServiceController";

		if(window.parent && window.parent.window)
		{
			if(!loginToken)loginToken = window.parent.window.loginToken;
			if(!loginDataArea)loginDataArea = window.parent.window.loginDataArea;
		}
		
	  }
	  catch(e)
	  {
		url = "/GongqiERP/ServiceController";
	  }
	  
	 
	  var cache = [];
	  let data = 
	  JSON.stringify(defaults.command, function(key, value) {
	    if (typeof value === 'object' && value !== null) {
	        if (cache.indexOf(value) !== -1) {
				// Circular reference found, discard key
				var valueCpy = {};
				for(var innerKey in value)
				{
					//alert(typeof(value[innerKey]));
					if(typeof(value[innerKey]) != "object")
					{
						valueCpy[innerKey] = value[innerKey];
					}
				}
				/*JSON.parse(JSON.stringify(value,function(key,value){
					if(innerCache.indexOf(value) !== -1)
					{

					}
					return;
				}));*/
	            return valueCpy;
	        }
	        // Store value in our collection
	        cache.push(value);
	    }
	    return value;
	  });
	  cache = null; // Enable garbage collection

	  //let data = JSON.stringify(command);
	  let postdata = {request:data};
	  let resultType = "json";
	  return AjaxRemoteUtil.ajaxPost(url,postdata,resultType,defaults.sync,defaults.resultFunction,
	  							defaults.faultFunction,defaults.successIngnoreStatus,{
	  								autoLock:defaults.autoLock,autoUnlock:defaults.autoUnlock,localLock:defaults.localLock,
	  								lockText:defaults.lockText,logArg:obj,domain:domain,loginToken:loginToken,loginDataArea:loginDataArea
	  							});
	}

	static addTokenWithCommand2(options)
	{
	  var defaults = 
	  {
		command:null,resultFunction:null,sync:true,faultFunction:null,autoLock:true,
		autoUnlock:true,localLock:true,autoCreateGongqiSession:true,_ishttps:false,logArgs:null,
		_iszhiding:false,fixCallFaultFunc:false,successIngnoreStatus:false,lockText:"系统正在拉取数据 请稍后...",relativeUrl:false
	  };

	  Object.assign(defaults, options);
	  if(defaults.command)
	  	defaults.command.requestUUID = CommonUtil.guid();
	  let obj;
	  let userInfos;
	  try
	  {
		userInfos = window.userInfos || window.parent.window.userInfos;
	  }
	  catch(e)
	  {
		//如果是跨域 如外链应用 需要自动登录 则该接口日志记录不需要用户信息 自动登录完成以后  window.userInfos自然会获取用户信息
	  }
	  if(!userInfos)userInfos={};
	  if(defaults.command && userInfos)
	  {
		  if(!(
			  defaults.command.classType == "service"&&defaults.command.className == "gongqi.erp.framework.services.ClientLoggingService"&&defaults.command.methodName=="saveLog"
		  ))
		  {
			  let command = defaults.command;
			  obj = {remoteClass:"java.util.Map"};
			  obj.requestId = command.requestUUID;
			  obj.dataArea = userInfos.subSysId;
			  obj.userId = userInfos.userId;
			  obj.userName = userInfos.userName;
			  obj.clientSessionId = userInfos.userSessionId;
			  obj.startDateTime = new Date().getTime();
			  obj.classType = command.classType;
			  obj.className = command.className;
			  obj.methodName = command.methodName;
			  obj.remark = (command.logArgs&&command.logArgs.length>0)?JSON.stringify(command.logArgs):"";
		  }
	  }

	  let url = options.url;
	  let loginToken = window.parent.loginToken;
	  let loginDataArea = window.parent.loginDataArea;
	  let domain;	 
	  var cache = [];
	  let data = 
	  JSON.stringify(defaults.command, function(key, value) {
	    if (typeof value === 'object' && value !== null) {
	        if (cache.indexOf(value) !== -1) {
				// Circular reference found, discard key
				var valueCpy = {};
				for(var innerKey in value)
				{
					//alert(typeof(value[innerKey]));
					if(typeof(value[innerKey]) != "object")
					{
						valueCpy[innerKey] = value[innerKey];
					}
				}

	            return valueCpy;
	        }
	        cache.push(value);
	    }
	    return value;
	  });
	  cache = null;

	  let postdata = {request:data};
	  let resultType = "json";
	  return AjaxRemoteUtil.ajaxPost2(url,postdata,resultType,defaults.sync,defaults.resultFunction,
	  							defaults.faultFunction,defaults.successIngnoreStatus,{
	  								autoLock:defaults.autoLock,autoUnlock:defaults.autoUnlock,localLock:defaults.localLock,
	  								lockText:defaults.lockText,logArg:obj,loginToken:loginToken,loginDataArea:loginDataArea,relativeUrl:true,domain:options.domain,shortName:options.shortdomain
	  							});
	}

	static call(
		className,
		methodName,
		returnType,
		result_Handler,
		sync,
		fault_Handler,
		...args)
	{
		
		var command = Command.createService(className, methodName, returnType);
		for(var arg of args)
		{
			command.appendArg(arg);
		}
		var remoteArg = {command:command,resultFunction:result_Handler,sync:sync,faultFunction:fault_Handler};
		ServiceHelper.addTokenWithCommand(remoteArg);
	}
}


// WEBPACK FOOTER //
// ./src/remote/ServiceHelper.js